import { useEffect, useRef, useState } from "react";
import { IconImg } from "../../contents/Icons";
import { StyledComboBox } from "./style";
import { Util } from "../../util/Util";

/**
 *
 * @param {Object} param
 * @param {Array} param.options - { label: string, value: any }
 * @param {string} param.placeholder
 * @param {any} param.value
 * @param {function} param.onChange
 * @param {boolean} param.multiSelectMode
 * @returns
 */
export const ComboBox = ({
  options,
  placeholder,
  value,
  onChange,
  multiSelectMode,
}) => {
  const comboBoxRef = useRef(null);
  const [listView, setListView] = useState(false);
  const [label, setLabel] = useState();

  const handleOnChange = (selected) => {
    onChange(selected.value);
    if (!multiSelectMode) setListView(false);
  };

  useEffect(() => {
    if (value !== undefined && value !== null) {
      if (typeof value === "object" && value.includes("ALL")) {
        setLabel("전체");
      } else {
        const findLabel = options.find(
          (option) =>
            option.value === (multiSelectMode ? value[value.length - 1] : value)
        );
        setLabel(findLabel ? findLabel.label : findLabel);
      }
    }
  }, [value]);

  useEffect(() => {
    if (comboBoxRef.current) Util.handleObjectClose(comboBoxRef, setListView);
  }, [comboBoxRef]);

  return (
    <StyledComboBox>
      <div className="combo-box-container">
        <div
          ref={comboBoxRef}
          className={`combo-box${
            multiSelectMode
              ? value.length
                ? " selected"
                : ""
              : value !== undefined && value !== null
              ? " selected"
              : ""
          }${listView ? " active" : ""}`}
          onClick={() => setListView(!listView)}
        >
          <p className="label">{label ? label : placeholder || ""}</p>
          <IconImg.CaretDown />
        </div>
        {listView && (
          <ul
            className="combo-list"
            onMouseDown={(e) => {
              if (multiSelectMode) {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
          >
            {options.map((option, index) => (
              <li
                key={index}
                className="list"
                onMouseDown={() => handleOnChange(option)}
              >
                {multiSelectMode && value && (
                  <input
                    type="checkbox"
                    name={option.label}
                    checked={value.includes(option.value)}
                    onChange={() => {}}
                  />
                )}
                <p>{option.label}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </StyledComboBox>
  );
};
